import TagToCreateDTO from '@/core/admin/DTO/TagToCreateDTO';
import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { container } from 'tsyringe';
import { TagsService } from '../services/TagsService';

export default async function createTagUseCase(createTagDTO: TagToCreateDTO, currentUser: CurrentUser) {
  return await container.resolve<TagsService>('TagsService').createTag(createTagDTO, currentUser);
}
